// extracted by mini-css-extract-plugin
module.exports = {"sale":"sale-module--sale--4iCSd","title":"sale-module--title--3X5b5","description":"sale-module--description--zYdsM","linkWrapper":"sale-module--link-wrapper--VD3Kr"};